export const mockData = {
  testimonials: {
    en: [
      {
        text: "Perfect app. To put it bluntly: To be warmly recommended to everyone. Immediately creates a higher quality of life. I will never use a smartphone again without this app. Big thanks to the BacktoMe developers.",
        author: "Able",
        role: "user of BacktoMe"
      },
      {
        text: "Helps me with my ADHD! I am not on meds and I am able to embrace having a smartphone!! YAY for this app. It has helped being so much peace to having a smart device.",
        author: "A. W.",
        role: "user of BacktoMe"
      },
      {
        text: "This app helped me repair my relationship with my phone. I no longer feel enslaved to my phone and rarely use it for mindless entertainment. Now it is a tool that benefits me. I am a mental health therapist and I recommend this app to anyone wanting to improve their mental health!",
        author: "Justin",
        role: "mental health therapist"
      },
      {
        text: "Everyone should be using this. Decreased my phone usage by a few hours a day and increased my productivity 10x. Great app.",
        author: "JJ",
        role: "user of BacktoMe"
      }
    ],
    ar: [
      {
        text: "تطبيق مثالي. بكل صراحة: أوصي به بشدة للجميع. يخلق على الفور جودة حياة أعلى. لن أستخدم هاتفاً ذكياً مرة أخرى بدون هذا التطبيق. شكراً جزيلاً لفريق BacktoMe.",
        author: "عابل",
        role: "مستخدم BacktoMe"
      },
      {
        text: "يساعدني مع اضطراب نقص الانتباه! أنا لا أتناول أدوية وأستطيع احتضان امتلاك هاتف ذكي!! ياي لهذا التطبيق. لقد ساعدني كثيراً في السلام مع امتلاك جهاز ذكي.",
        author: "أ. و.",
        role: "مستخدم BacktoMe"
      },
      {
        text: "ساعدني هذا التطبيق على إصلاح علاقتي بهاتفي. لم أعد أشعر بالعبودية لهاتفي ونادراً ما أستخدمه للترفيه غير المجدي. الآن هو أداة تفيدني. أنا معالج نفسي وأوصي بهذا التطبيق لأي شخص يريد تحسين صحته العقلية!",
        author: "جاستن",
        role: "معالج نفسي"
      },
      {
        text: "يجب على الجميع استخدام هذا. قلل استخدامي للهاتف بضع ساعات يومياً وزاد إنتاجيتي 10 أضعاف. تطبيق رائع.",
        author: "ج.ج.",
        role: "مستخدم BacktoMe"
      }
    ]
  },
  faqs: {
    en: [
      {
        question: "how does it work?",
        answer: "BacktoMe is a custom home screen for android phones that replaces your default home screen. its unique and minimalist user interface is designed to support mindful phone use and avoid mindlessly spending hours on your phone with a traditional home screen."
      },
      {
        question: "what plans does BacktoMe offer?",
        answer: "you can choose from monthly, annual or one-time purchase. all three plans include a free trial. please see the purchase screen for details."
      },
      {
        question: "is it safe for my phone?",
        answer: "yes, absolutely! you install BacktoMe the same way you install other apps from your app store. you can uninstall it anytime and return to your default home screen (but we hope that won't be needed!)."
      },
      {
        question: "is my privacy protected if I download the app?",
        answer: "yes! we do not sell any personally identifiable information (PII) to 3rd parties. the application is GDPR compliant. for more details, please read our privacy policy at bck.ai/privacy."
      },
      {
        question: "what is it like to use?",
        answer: "when you use BacktoMe, you quickly start to realize the unhealthy usage patterns your phone was causing. the peace of mind and happiness this minimalist phone brings is very addictive and you will not want to go back to your default home screen after using it for a few days."
      },
      {
        question: "will it work on my phone?",
        answer: "currently all android phones with os version 6.0 and higher, which represents the majority of currently active android phones, are supported."
      },
      {
        question: "how does the password lock feature work?",
        answer: "Our new password lock feature allows you to lock your phone into minimal mode for a set duration. Once locked, you cannot exit minimal mode until the timer expires, even if you want to. This helps you stay focused during deep work sessions, studying, or when breaking phone addiction. Simply set a password and duration, and your phone will remain in distraction-free mode."
      }
    ],
    ar: [
      {
        question: "كيف يعمل؟",
        answer: "BacktoMe هو شاشة رئيسية مخصصة لهواتف أندرويد تحل محل شاشتك الرئيسية الافتراضية. واجهة المستخدم الفريدة والبسيطة مصممة لدعم الاستخدام الواعي للهاتف وتجنب قضاء ساعات طويلة على هاتفك بدون تفكير مع الشاشة الرئيسية التقليدية."
      },
      {
        question: "ما هي الخطط التي يقدمها BacktoMe؟",
        answer: "يمكنك الاختيار من بين الاشتراك الشهري أو السنوي أو الشراء لمرة واحدة. تتضمن جميع الخطط الثلاث تجربة مجانية. يرجى الاطلاع على شاشة الشراء للحصول على التفاصيل."
      },
      {
        question: "هل هو آمن لهاتفي؟",
        answer: "نعم، بالتأكيد! تقوم بتثبيت BacktoMe بنفس الطريقة التي تثبت بها التطبيقات الأخرى من متجر التطبيقات. يمكنك إلغاء تثبيته في أي وقت والعودة إلى شاشتك الرئيسية الافتراضية (لكننا نأمل ألا تحتاج ذلك!)."
      },
      {
        question: "هل خصوصيتي محمية إذا قمت بتنزيل التطبيق؟",
        answer: "نعم! نحن لا نبيع أي معلومات تعريف شخصية (PII) لأطراف ثالثة. التطبيق متوافق مع اللائحة العامة لحماية البيانات (GDPR). لمزيد من التفاصيل، يرجى زيارة bck.ai/privacy."
      },
      {
        question: "كيف يكون الاستخدام؟",
        answer: "عندما تستخدم BacktoMe، تبدأ بسرعة في إدراك أنماط الاستخدام غير الصحية التي كان يسببها هاتفك. راحة البال والسعادة التي يجلبها هذا الهاتف البسيط مسببة للإدمان الشديد ولن ترغب في العودة إلى شاشتك الرئيسية الافتراضية بعد استخدامه لبضعة أيام."
      },
      {
        question: "هل سيعمل على هاتفي؟",
        answer: "حالياً جميع هواتف أندرويد بنظام التشغيل 6.0 وأعلى، والتي تمثل غالبية هواتف أندرويد النشطة حالياً، مدعومة."
      },
      {
        question: "كيف تعمل ميزة القفل بكلمة المرور؟",
        answer: "تتيح لك ميزة القفل الجديدة بكلمة المرور قفل هاتفك في الوضع البسيط لمدة محددة. بمجرد القفل، لا يمكنك الخروج من الوضع البسيط حتى ينتهي المؤقت، حتى لو أردت ذلك. يساعدك هذا على البقاء مركزاً أثناء جلسات العمل العميق أو الدراسة أو عند كسر إدمان الهاتف. ببساطة قم بتعيين كلمة مرور ومدة، وسيظل هاتفك في وضع خالٍ من التشتيت."
      }
    ]
  }
};